import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import { Observable, map } from "rxjs";
import { IResponse } from "../models/response";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class RoomService {
  constructor(private _http: HttpClient) {}

  getDepartmentByProjectId(
    projectId: string,
    isRoomTypical?: boolean
  ): Observable<any> {
    isRoomTypical = isRoomTypical ? true : false;
    return this._http
      .get(
        apiconstants.API_DEPARTMENTS +
          `/${projectId}?isroomtypical=${isRoomTypical}`
      )
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getRoomsByDepartmentId(
    depId: string,
    isRoomTypical?: boolean
  ): Observable<any> {
    isRoomTypical = isRoomTypical ? true : false;
    return this._http
      .get(
        apiconstants.API_ROOMS_BY_DEPARTMENT +
          `/${depId}?isroomtypical=${isRoomTypical}`
      )
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getRoomByRoomDetails(roomId: string): Observable<any> {
    return this._http.get(apiconstants.API_RXR + `/${roomId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getRoomDetails(roomId: string): Observable<any> {
    return this._http.get(apiconstants.API_ROOMS + `/${roomId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getChangeHistoryByRoomId(params, roomId: string): Observable<any> {
    return this._http
      .get(apiconstants.API_CHANGE_HISTORY + `/${roomId}`, { params })
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getRoomLayoutsByRoomId(roomId: string): Observable<any> {
    return this._http.get(apiconstants.API_GET_LAYOUTS + `/${roomId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getRxrByJsnId(jsnId: string) {
    return this._http
      .get(apiconstants.API_GET_JSN_RXR_DETAIL + `/${jsnId}`)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  updateRoom(roomId: string, params): Observable<any> {
    return this._http.put(apiconstants.API_ROOMS + "/" + roomId, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  updateRoomNote(roomId: string, params): Observable<any> {
    return this._http
      .post(apiconstants.API_UPDATE_ROOM_NOTE + "/" + roomId, params)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  updateRXR(rxrId, params): Observable<any> {
    return this._http
      .post(apiconstants.API_ROOMBYROOM + "/" + rxrId, params)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  deleteRXR(rxrId): Observable<any> {
    return this._http.delete(apiconstants.API_ROOMBYROOM + "/" + rxrId).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  deleteRXRNote(historyId): Observable<any> {
    return this._http
      .delete(apiconstants.API_RXR_CHANGE_HISTORY + "/" + historyId)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  updateNoteData(id: string, note: string): Observable<any> {
    let params = {
      id: id,
      name: note,
    };
    return this._http.post(apiconstants.API_RXR_CHANGE, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllMiscContacts(departmentId: string) {
    let params = {
      department: departmentId,
    };
    return this._http.get(apiconstants.API_MISC_CONTACTS, { params }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getRoomsByProjectId(projectId: string): Observable<any> {
    return this._http
      .get(apiconstants.API_PROJECT + `${projectId}` + apiconstants.API_ROOM)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getRoomsType(departmentId: string, projectId: string): Observable<any> {
    const isRoomTypical = false;
    return this._http
      .get(
        apiconstants.API_ROOM_TYPE_DEPARTMENT +
          "/" +
          `${departmentId}?isroomtypical=${isRoomTypical}&projectid=${projectId}`
      )
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getRoomsName(departmentId: string, projectId: string): Observable<any> {
    const isRoomTypical = false;
    return this._http
      .get(
        apiconstants.API_ROOM_NAME_DEPARTMENT +
          "/" +
          `${departmentId}?isroomtypical=${isRoomTypical}&projectid=${projectId}`
      )
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getRoomByTypeCodeDepartmentId(
    isRoomTypical: boolean,
    roomCode: string,
    roomType: string,
    departmentId: string,
    projectId: string
  ) {
    let url = `${
      apiconstants.API_ROOM_BY_CODE_TYPE_DEPARTMENT +
      "?" +
      "isroomtypical=" +
      isRoomTypical
    }`;
    if (departmentId != "ALL") {
      url = url + `&departmentid=${departmentId}`;
    }
    if (projectId) {
      url = url + `&projectid=${projectId}`;
    }
    if (roomCode) {
      url = url + `&roomcode=${roomCode}`;
    }
    if (roomType) {
      url = url + `&roomtype=${roomType}`;
    }
    return this._http.get(url).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getAICheckPastIssues(payload: any): Observable<any> {
    return this._http
      .get(
        apiconstants.API_GET_ALL_AI_CHECK_ISSUES +
          `/${payload.roomId}?take=` +
          `${payload.take}&page=` +
          `${payload.page}&pastissues=` +
          `${payload.pastissues}`
      )
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getAICheckCurrentIssues(payload: any): Observable<any> {
    return this._http
      .get(
        apiconstants.API_GET_ALL_AI_CHECK_ISSUES +
          `/${payload.roomId}?take=` +
          `${payload.take}&page=` +
          `${payload.page}&currentissues=` +
          `${payload.currentissues}`
      )
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }
  getIssueResolutionTypes(): Observable<any> {
    return this._http
      .get(
        apiconstants.API_GET_ISSUE_RESOLUTION_TYPES)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }
}
